{
  "version": 1,
  "asset_id": "ce70fda2-1e9d-4dbe-b7d2-c27cea5a5c91",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/ce70fda2-1e9d-4dbe-b7d2-c27cea5a5c91/hiatal-intro-fundus-en-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/ce70fda2-1e9d-4dbe-b7d2-c27cea5a5c91/hiatal-intro-fundus-en-800.webp",
  "original_filename": "hiatal-intro-fundus-en-800.webp",
  "size": 43898,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:54:33Z"
}
